import { useRoutines } from '../../../lib/routines';
import { useTasks } from '../../../lib/tasks';

// Whether the four summary tiles (Tasks · Routines · Files · Apps) can be drawn as one row.
//
// **Two of the four render NOTHING until their read lands** — `TasksSummary` and `RoutinesSummary`
// both `return null` unless their state is `ready`, while the Files and Apps tiles paint immediately
// off a fallback blurb. So without a gate the row assembles itself in front of the reader: three tiles,
// then a fourth shoving them along a beat later. Tasks and routines are separate queries, so it can
// happen twice.
//
// The gate is on `loading` specifically, not on `ready`: a FAILED read must let the row through, or one
// dead query hides the other three tiles forever. A tile whose read failed simply stays out.
//
// Every caller shares these two queries with the tiles themselves — React Query dedupes them, so the
// gate costs no extra request. Pass the Space's id on a Space-scoped row so the gate waits for the same
// scoped reads its tiles will show.
export function useSummaryTilesReady(workspaceId?: string): boolean {
  const { state: tasks } = useTasks(workspaceId);
  const { state: routines } = useRoutines(workspaceId);
  return tasks.kind !== 'loading' && routines.kind !== 'loading';
}
